import React, { useState } from "react";
import { AiOutlineMail } from "react-icons/ai";
import { BsWhatsapp } from "react-icons/bs";
import {
  FaHeart,
  FaInfoCircle,
  FaPlane,
  FaShareAlt,
  FaLongArrowAltLeft,
  FaLongArrowAltRight,
  FaPlus,
} from "react-icons/fa";
import { HiOutlineRefresh } from "react-icons/hi";

import { MdContentCopy } from "react-icons/md";
import { FormattedMessage, FormattedNumber, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import Popup from "reactjs-popup";
import {
  availabilityAndPriceCheck,
  getLink2Share,
  search,
  setOfferMemo,
} from "amadeusredux/lib/api";

import InfoPopup from "./InfoPopup";
import { RiCloseFill } from "react-icons/ri";
import { sendLink2Agency } from "amadeusredux/lib/bookingSlice";
import InfoPopupHover from "../components/InfoPopupHover";
import CancellationOptions from "../CancellationOptions";
import { setMarked } from "amadeusredux/lib/offersSlice";
import FlightLocations from "../hotel/FlightLocations";
import OfferFlight from "../hotel/OfferFlight";
import {
  boardTypes,
  paymentOptions,
  propertyFromArray,
  roomViews,
  currencySymbol,
  roomAttributes,
} from "../utils";

import { BsSuitHeartFill, BsSuitHeart } from "react-icons/bs";
import { FiUpload, FiShare2 } from "react-icons/fi";
import { setHotelPage, setOfferId } from "amadeusredux/lib/hotelSlice";
import { setInbounddate, setOutbounddate } from "amadeusredux/lib/searchSlice";

const nf = new Intl.NumberFormat("de-DE", { minimumFractionDigits: 2 });
const nf1 = new Intl.NumberFormat("de-DE", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

export default function HotelOfferVoucher(props) {
  const {
    extended,
    offer,
    availabilityButton,
    selectedTAMarketingAction,
    selectedTOMarketingAction,
    mode,
    bookingprice,
    bookingpersonprice,
    reservationselected,
    betterOffersButton,
    alternativeTransportsButton,

    flexbooked,
  } = props;

  const reload = () => {
    dispatch(setHotelPage(1));
    dispatch(setOfferId(offer.OfferID));

    dispatch(
      setOutbounddate(
        offer.TravelDateInfo.DepartureDate
          ? offer.TravelDateInfo.DepartureDate
          : offer.TravelDateInfo.CheckInDate
      )
    );

    dispatch(
      setInbounddate(
        offer.TravelDateInfo.ReturnDate
          ? offer.TravelDateInfo.ReturnDate
          : offer.TravelDateInfo.CheckOutDate
      )
    );
    search(dispatch, true, false, 0, true);
  };

  const dispatch = useDispatch();
  const hotelOfferInfos = useSelector((state) => state.hotel.hotelOfferInfos);
  const stations = hotelOfferInfos.StationDictionary;
  const holidayType = useSelector((state) => state.search.holidayType);
  const debug = useSelector((state) => state.system.debug);
  const infos = useSelector((state) => state.properties.infos);

  const multiroomdivider = useSelector(
    (state) => state.search.multiroomdivider
  );

  const [shareOptionsHidden, setShareOptionsHidden] = React.useState(true);
  const [shareLink, setShareLink] = React.useState({});
  const [uploadStep, setUploadStep] = React.useState(0);
  const [uploadOpen, setUploadOpen] = React.useState(false);
  const [requestData, setRequestData] = React.useState({
    name: "",
    mail: "",
    phone: "",
    remark: "",
  });

  const [packageInfo, setPackageInfo] = React.useState({
    outbound: "",
    inbound: "",
    offerId: "",
  });

  const sessionId = useSelector((state) => state.system.sessionId);

  const offerdiv = React.useRef(null);

  const [popupFlightOpen, setPopupFlightOpen] = React.useState("");

  let checked = false;
  if (offer?.bookinginfo) checked = true;

  const intl = useIntl();
  const df = new Intl.DateTimeFormat(intl.locale, {
    weekday: "short",
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  let hotels = hotelOfferInfos.HotelDictionary;

  const hotel = hotels
    ? hotels.Hotel.find(
        (e) =>
          e.HotelID ===
          offer?.OfferServices?.Package?.Accommodation?.HotelRef?.HotelID
      )
    : {};

  let transferincl = false;
  if (offer?.OfferProperties?.TransferInfos) {
    if (
      Array.isArray(offer.OfferProperties.TransferInfos) &&
      offer.OfferProperties.TransferInfos.includes("TransferIncluded")
    ) {
      transferincl = true;
    }
  }
  let railandfly = false;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RailAndFly")
    ) {
      railandfly = true;
    }
  }

  let rentalCar = false;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("RentalCar")
    ) {
      rentalCar = true;
    }
  }
  let freeRebook = false;
  if (offer?.OfferProperties?.OfferIncludes) {
    if (
      Array.isArray(offer.OfferProperties.OfferIncludes) &&
      offer.OfferProperties.OfferIncludes.includes("FreeRebooking")
    ) {
      freeRebook = true;
    }
  }

  let cancellationoption = "";
  if (offer?.OfferProperties?.CancellationOption) {
    cancellationoption = offer?.OfferProperties?.CancellationOption;
  }

  let realprice = 0;

  if (offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._) {
    realprice = offer?.bookinginfo?.PriceInformation?.TotalPrice?.Amount?._ * 1;
  }

  if (realprice === 0 && offer.PriceInfo.Price.value) {
    realprice =
      offer.PriceInfo.Price.value * (offer.adults * 1 + offer.children * 1);
  }

  let reducedprice = realprice;
  let flexprice = -1;

  if (mode !== "booking" && realprice && offer.flexbooked) {
    if (
      Array.isArray(offer.MarketingActions) &&
      offer.MarketingActions.length > 0 &&
      !isNaN(
        offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice
      ) &&
      offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice
    ) {
      realprice =
        realprice +
        offer.MarketingActions[0].flexconditions.flexoptions.flexoptionprice *
          1;
      flexprice =
        offer.MarketingActions[0].flexconditions.flexoptions.flexoptionprice *
        1;
    }
  }

  if (mode === "booking" && realprice && flexbooked) {
    if (
      Array.isArray(offer.MarketingActions) &&
      offer.MarketingActions.length > 0 &&
      !isNaN(
        offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice
      ) &&
      offer.MarketingActions[0].flexconditions?.flexoptions?.flexoptionprice
    ) {
      realprice =
        realprice +
        offer.MarketingActions[0].flexconditions.flexoptions.flexoptionprice *
          1;
      flexprice =
        offer.MarketingActions[0].flexconditions.flexoptions.flexoptionprice *
        1;
    }
  }

  let status = 0;

  if (offer?.bookinginfo) {
    if (
      offer?.bookinginfo?.Status?.Status === "Available" ||
      offer?.bookinginfo?.Status?.Status === "ToConfirm" ||
      offer?.bookinginfo?.Status?.Status === "OnRequest"
    ) {
      status = 1;
    } else {
      status = -1;
    }
  }

  //console.log(offer);

  let marketingGroup = "";

  //console.log(offer?.TravelDateInfo);

  return (
    <div
      className={
        (extended ? "vouchermainextended " : "vouchermain ") +
        (status === -1 ? "voucherno" : status === 1 ? "voucheryes" : "")
      }
    >
      {status === 1 && mode !== "booking" && (
        <div style={{ position: "relative" }} className="voucheravailableframe">
          <div className="voucheravailable">Diese Reise ist verfügbar</div>
        </div>
      )}
      <div ref={offerdiv} className="hoteloffervoucher1">
        <div
          style={{
            marginTop: status === 1 && mode !== "booking" ? -28 : undefined,
          }}
          className="hoteloffervoucher2"
        >
          <div className="hoteloffervoucher3">
            <div>
              <div
                onClick={() => console.log(offer)}
                className="hotelofferhotelname"
              >
                {offer.destination?.Name}{" "}
                {offer.dboffer && (
                  <>
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => reload()}
                    >
                      &nbsp;
                      <HiOutlineRefresh />{" "}
                    </span>
                    <InfoPopupHover
                      trigger={
                        <span>
                          <FaInfoCircle className="filterinfo" />
                        </span>
                      }
                      objectcontent={
                        <>
                          Originaldaten der Speicherung. Drücken Sie&nbsp;
                          <HiOutlineRefresh /> wenn die Daten aktualisert werden
                          sollen{" "}
                        </>
                      }
                      position={"right center"}
                    ></InfoPopupHover>
                  </>
                )}
              </div>
              <div className="hotelofferpersondays">
                <div>
                  <FormattedMessage
                    id="persons"
                    values={{ num: offer.adults * 1 + offer.children * 1 }}
                  />
                </div>
                <div>&nbsp;|&nbsp;</div>
                {holidayType.flight && (
                  <div>
                    {offer.TravelDateInfo.TripDuration
                      ? offer.TravelDateInfo.TripDuration
                      : offer.TravelDateInfo.OvernightStays}{" "}
                    Tage
                  </div>
                )}
                {holidayType.flight && <div>&nbsp;|&nbsp;</div>}
                <div>{offer.TravelDateInfo.OvernightStays} Übernachtungen</div>
                <div>&nbsp;|&nbsp;</div>
                <div>
                  {offer.OfferServices.Package.Flight && (
                    <FlightLocations offer={offer} stations={stations} />
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="hoteloffervoucher6">
            <div className="hoteloffervoucher7">
              {/*<div className="hoteloffervoucher32">
                <img
                  alt="plane"
                  src="https://holiday.placelogg.com/holidaymedia/orange_plane.png"
                  className="hoteloffervoucher8"
                />
                  </div>*/}
              <div className="hoteloffervoucher9"></div>
              <div className="hoteloffervoucher10">
                <div className="hoteloffervoucher11"></div>
                <InfoPopupHover
                  nested={true}
                  trigger={
                    <div
                      style={{
                        marginRight: 16,
                        cursor: "pointer",
                      }}
                      className="shareicon"
                    >
                      <FiUpload onClick={() => setUploadOpen(true)}></FiUpload>
                    </div>
                  }
                  content={infos?.uploadsymbol}
                  position={"top center"}
                ></InfoPopupHover>
                <Popup
                  modal
                  closeOnDocumentClick={false}
                  onOpen={() =>
                    getLink2Share(
                      offer.OfferID,
                      sessionId,
                      hotelOfferInfos,
                      offer
                    )
                      .then((response) => response.json())
                      .then((data) => {
                        setShareLink(data?.ret[0] ? data?.ret[0] : {});
                      })
                      .catch((e) => console.log(e))
                  }
                  open={uploadOpen}
                >
                  <div className="upload1 colordef">
                    <div className="hotelinfoclose">
                      <RiCloseFill
                        onClick={() => {
                          setUploadOpen(false);
                          setUploadStep(0);
                        }}
                        style={{ fontSize: "1.5rem", margin: "auto" }}
                      />
                    </div>
                    {uploadStep === 0 ? (
                      <>
                        <div className="upload2">
                          Wir machen Ihnen gerne ein personalisiertes Angebot zu
                          Ihrer Traumreise
                        </div>
                        <div className="upload10">
                          <div>Name*</div>
                          <input
                            className="upload3"
                            value={requestData.name}
                            onChange={(e) => {
                              setRequestData({
                                ...requestData,
                                name: e.target.value,
                              });
                            }}
                            type="text"
                          ></input>
                        </div>
                        <div className="upload4">
                          <div className="upload5">
                            <div>E-Mail**</div>
                            <input
                              className="upload7"
                              value={requestData.mail}
                              onChange={(e) => {
                                setRequestData({
                                  ...requestData,
                                  mail: e.target.value,
                                });
                              }}
                              type="text"
                            ></input>
                          </div>
                          <div className="upload6" />
                          <div className="upload5">
                            <div>Telefon**</div>
                            <input
                              className="upload7"
                              value={requestData.phone}
                              onChange={(e) => {
                                setRequestData({
                                  ...requestData,
                                  phone: e.target.value,
                                });
                              }}
                              type="text"
                            ></input>
                          </div>
                        </div>
                        <div className="upload10">
                          <div>Zusätzliche Informationen</div>
                          <textarea
                            className="upload8"
                            onChange={(e) => {
                              setRequestData({
                                ...requestData,
                                remark: e.target.value,
                              });
                            }}
                            value={requestData.remark}
                            type="text"
                          ></textarea>
                        </div>
                        <div className="upload11">*erforderliche Daten</div>
                        <div className="upload11">
                          **Mail oder Telefon erforderlich
                        </div>
                        <div>
                          <button
                            disabled={
                              !requestData.name ||
                              (!requestData.mail && !requestData.phone)
                            }
                            className={
                              requestData.name &&
                              (requestData.mail || requestData.phone)
                                ? "upload9"
                                : "upload9disabled"
                            }
                            onClick={() => {
                              setUploadStep(1);
                              console.log({
                                ...requestData,
                                link: shareLink.link,
                              });
                              dispatch(
                                sendLink2Agency({
                                  ...requestData,
                                  link: shareLink.link,
                                })
                              );
                            }}
                          >
                            Senden
                          </button>
                        </div>
                      </>
                    ) : (
                      <div>
                        <div className="wrapper">
                          {" "}
                          <svg
                            className="checkmark"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 52 52"
                          >
                            {" "}
                            <circle
                              className="checkmark__circle"
                              cx="26"
                              cy="26"
                              r="25"
                              fill="none"
                            />{" "}
                            <path
                              className="checkmark__check"
                              fill="none"
                              d="M14.1 27.2l7.1 7.2 16.7-16.8"
                            />
                          </svg>
                        </div>
                        <div className="upload12">Vielen Dank</div>
                        <div className="upload13">
                          Ihre Anfrage wird schnellst möglich bearbeitet
                        </div>
                        <div>
                          <button
                            className="upload9"
                            onClick={() => {
                              setUploadStep(0);
                              setUploadOpen(false);
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </Popup>
                <InfoPopupHover
                  trigger={
                    <div
                      style={{
                        marginRight: 16,
                        cursor: "pointer",
                      }}
                      className="shareicon"
                      id="shareicon"
                      onClick={() => {
                        getLink2Share(
                          offer.OfferID,
                          sessionId,
                          hotelOfferInfos,
                          offer
                        )
                          .then((response) => response.json())
                          .then((data) => {
                            setShareLink(data?.ret[0] ? data?.ret[0] : {});
                          })
                          .catch((e) => console.log(e));
                      }}
                    >
                      <Popup
                        trigger={(open) => (
                          <div>
                            <FiShare2
                              onClick={() => {
                                getLink2Share(
                                  offer.OfferID,
                                  sessionId,
                                  hotelOfferInfos,
                                  offer
                                )
                                  .then((response) => response.json())
                                  .then((data) => {
                                    setShareLink(
                                      data?.ret[0] ? data?.ret[0] : {}
                                    );
                                  })
                                  .catch((e) => console.log(e));
                              }}
                            />
                          </div>
                        )}
                      >
                        <div className="sharebackground">
                          <MdContentCopy
                            title="Zwischenablage"
                            className="shareicon"
                            onClick={() =>
                              navigator.clipboard.writeText(shareLink.link)
                            }
                          />{" "}
                          <a
                            target="_blank"
                            className="shareicona"
                            href={
                              "https://wa.me/?text=" +
                              encodeURIComponent(
                                shareLink.link + " " + shareLink.info
                              )
                            }
                          >
                            <BsWhatsapp
                              title="WhatsApp"
                              className="shareicon"
                            />
                          </a>
                          <a
                            target="_blank"
                            className="shareicona"
                            href={`mailto:?body=Dieses%20Angebot%20habe%20ich%20für%20Dich%20ausgesucht:%0A%0A${encodeURIComponent(
                              shareLink.link
                            )}%0A&subject=Unsere%20Reiseplanung`}
                          >
                            <AiOutlineMail
                              title="Email"
                              className="shareicon"
                            />
                          </a>
                        </div>
                      </Popup>
                    </div>
                  }
                  content={infos?.connectsymbol ? infos.connectsymbol : ""}
                  position={"top center"}
                ></InfoPopupHover>
                <InfoPopupHover
                  trigger={
                    <div style={{ width: "20px", height: "20px" }}>
                      <svg className="hearticon">
                        <defs>
                          <linearGradient
                            id="testGradient"
                            gradientTransform="rotate(90)"
                          >
                            <stop offset="0%" stopColor="rgba(0,0,0,0.5)" />
                            <stop
                              offset="60%"
                              stopColor="rgba(255,255,255,1)"
                            />
                          </linearGradient>
                        </defs>
                        <BsSuitHeartFill
                          className="hearticonfill heartbackground"
                          fill="url(#testGradient)"
                          viewBox="-1 0 18 17"
                        ></BsSuitHeartFill>
                      </svg>
                      <svg className="hearticon">
                        <BsSuitHeartFill
                          className={
                            "hearticonfill " +
                            (Array.isArray(offer.MarketingActions) &&
                            offer.MarketingActions.length > 0 &&
                            offer.MarketingActions[0].marked
                              ? "heartlinefill"
                              : "heartline")
                          }
                          fill="transparent"
                          stroke="black"
                          strokeWidth="3%"
                          viewBox="-1 0 18 17"
                          onClick={() => {
                            setOfferMemo(
                              offer.OfferID,
                              hotel?.HotelCodes?.HotelGiataID,
                              sessionId,
                              dispatch,
                              hotelOfferInfos,
                              offer
                            );
                            dispatch(
                              setMarked({
                                offerId: offer.OfferID,
                                marked: !(
                                  Array.isArray(offer.MarketingActions) &&
                                  offer.MarketingActions.length > 0 &&
                                  offer.MarketingActions[0].marked
                                ),
                              })
                            );
                          }}
                        ></BsSuitHeartFill>
                      </svg>
                    </div>
                  }
                  content={infos?.favoritensymbol ? infos.favoritensymbol : ""}
                  position={"top center"}
                ></InfoPopupHover>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hoteloffervoucher14">
        <div className="hoteloffervoucher15">
          {holidayType.flight && (
            <div className="hoteloffervoucher16">
              {/*}
              <div >
                <img
                  style={{ margin: 32 }}
                  src={offer.TourOperator.TourOperatorImage}
                />
              </div>*/}
              <div className="hotelofferofferflight">
                {offer.OfferServices.Package.Flight && (
                  <>
                    <OfferFlight
                      offer={offer}
                      stations={stations}
                      verbose={false}
                      setPackageInfo={setPackageInfo}
                      packageInfo={packageInfo}
                    />
                  </>
                )}
                {!offer.OfferServices?.Package?.Flight && (
                  <div>
                    {df.format(new Date(offer.TravelDateInfo.CheckInDate))} -{" "}
                    {df.format(new Date(offer.TravelDateInfo.CheckOutDate))}
                  </div>
                )}
              </div>
              {status !== -1 ? (
                <div
                  className="hoteloffervoucher38"
                  onClick={() => {
                    if (!checked) {
                      availabilityAndPriceCheck(
                        dispatch,
                        sessionId,
                        offer.OfferID,
                        offer.adults,
                        offer.children,
                        undefined
                      );
                    }
                    setPopupFlightOpen(true);
                  }}
                >
                  Flug- und Gepäckinfos
                </div>
              ) : (
                <div className="hoteloffervoucher38"></div>
              )}
              <Popup
                open={popupFlightOpen && checked && status === 1}
                position="center"
                modal
                onClose={() => {
                  setPopupFlightOpen(false);
                }}
              >
                <div className="infopopup">
                  <div className="hotelinfoclose">
                    <RiCloseFill
                      onClick={() => setPopupFlightOpen(false)}
                      style={{ fontSize: "1.5rem", margin: "auto" }}
                    />
                  </div>
                  <div style={{ overflowY: "scroll", maxHeight: "500px" }}>
                    <div>
                      <OfferFlight
                        offer={offer}
                        stations={stations}
                        verbose={true}
                      />
                    </div>
                    <div style={{ marginTop: 16 }}>
                      Der Reiseveranstalter behält sich Änderungen der geplanten
                      Flugdaten im Rahmen der gesetzlichen und vertraglichen
                      Regelungen vor.
                    </div>
                  </div>
                </div>
              </Popup>
              <div className="betterplaceholder">
                {alternativeTransportsButton}
              </div>
            </div>
          )}
          <div
            className={
              "hoteloffervoucher17 " +
              (status === -1 ? "voucherno" : status === 1 ? "voucheryes" : "")
            }
          >
            <div className="hotelofferofferinfos">
              <div className="hotelofferofferroomsonst">
                <div className="hotelofferofferroom">
                  {multiroomdivider > 1 ? multiroomdivider + " x " : ""}
                  {offer.OfferServices.Package.Accommodation.Room.RoomName}{" "}
                </div>
                {!holidayType?.flight && offer?.TravelDateInfo?.CheckInDate && (
                  <div style={{ display: "flex", margin: "2px" }}>
                    <div>
                      <div>
                        <span style={{ marginRight: "10px" }}>
                          <FaLongArrowAltRight className="iconvoucher" />
                        </span>
                        <span>{"Anreise: "}</span>
                        <span style={{ fontWeight: "600" }}>
                          {df.format(
                            new Date(offer?.TravelDateInfo?.CheckInDate)
                          )}
                        </span>
                      </div>
                      <div>
                        <span style={{ marginRight: "10px" }}>
                          <FaLongArrowAltLeft className="iconvoucher" />
                        </span>
                        <span>{"Abreise: "}</span>
                        <span style={{ fontWeight: "600" }}>
                          {df.format(
                            new Date(offer?.TravelDateInfo?.CheckOutDate)
                          )}
                        </span>
                      </div>
                    </div>
                    <InfoPopupHover
                      trigger={
                        <div>
                          <FaInfoCircle className="filterinfo" />
                        </div>
                      }
                      content={infos?.hotel_check_in}
                      position={"right center"}
                    ></InfoPopupHover>
                  </div>
                )}
                {offer.OfferServices.Package.Accommodation.Room.RoomView !==
                  "NothingSpecial" && (
                  <div className="hotelofferofferboard">
                    <img
                      src="https://holiday.placelogg.com/holidaymedia/Auge.png"
                      className="iconvoucher"
                    />
                    <span className="vouchericontext">
                      {propertyFromArray(
                        roomViews,
                        offer.OfferServices.Package.Accommodation.Room.RoomView,
                        "value",
                        "label"
                      )}
                    </span>
                  </div>
                )}
                <div className="hotelofferofferboard">
                  {/*offer.OfferServices.Package.Accommodation.BoardType*/}
                  <img
                    src="https://holiday.placelogg.com/holidaymedia/Restaurant.png"
                    className="iconvoucher"
                  />
                  <span className="vouchericontext">
                    {propertyFromArray(
                      boardTypes,
                      offer.OfferServices.Package.Accommodation.BoardType,
                      "value",
                      "label"
                    )}
                    <span style={{ fontSize: "0.8em" }}>
                      &nbsp;&nbsp;|&nbsp; ZC:{" "}
                      {offer.OfferServices.Package.Accommodation.Room.RoomCode}
                      &nbsp;|&nbsp; HC:{" "}
                      {offer.OfferServices.Package.Accommodation.ServiceCode}
                    </span>
                  </span>
                </div>
                <div className="hotelofferofferroomsonst">
                  {Array.isArray(
                    offer.OfferServices?.Package?.Accommodation?.Room
                      ?.RoomAttributes
                  ) &&
                    offer.OfferServices?.Package?.Accommodation?.Room?.RoomAttributes.map(
                      (att) => {
                        return roomAttributes[att] ? (
                          <div>
                            <FaPlus />
                            <span className="vouchericontext">
                              {roomAttributes[att]}
                            </span>
                          </div>
                        ) : (
                          <></>
                        );
                      }
                    )}
                </div>
                <div className="hotelofferofferroomsonst">
                  {transferincl ? (
                    <>
                      <div>
                        <img
                          src="https://holiday.placelogg.com/holidaymedia/Bus.png"
                          className="iconvoucher"
                        />
                        <span className="vouchericontext">
                          <FormattedMessage id="transferincluded" />
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                      <div>
                        <img
                          src="https://holiday.placelogg.com/holidaymedia/Bus.png"
                          className="iconvoucher"
                        />
                        <span className="vouchericontext">
                          <FormattedMessage id="transfernotincluded" />
                        </span>
                      </div>
                    </>
                  )}{" "}
                  {railandfly ? (
                    <div className="hoteloffervoucher18">
                      <div>
                        <img
                          src="https://holiday.placelogg.com/holidaymedia/train.png"
                          className="iconvoucher"
                        />
                        <span className="vouchericontext">Zug zum Flug</span>
                      </div>
                    </div>
                  ) : null}{" "}
                  {rentalCar ? (
                    <div className="hoteloffervoucher18">
                      <div>
                        <img
                          src="https://holiday.placelogg.com/holidaymedia/Mietwagen.png"
                          className="iconvoucher"
                        />
                        <span className="vouchericontext">Mietwagen</span>
                      </div>
                    </div>
                  ) : null}{" "}
                  {/*cancellationoption*/}
                  {debug && <>{offer?.OfferProperties?.CancellationOption}</>}
                  {packageInfo.outbound ? (
                    <div className="hoteloffervoucher18">
                      <div>
                        <img
                          src="https://holiday.placelogg.com/holidaymedia/koffer.png"
                          className="iconvoucher"
                        />
                        <span className="vouchericontext">
                          <span title="Hinflug">H:</span> {packageInfo.outbound}{" "}
                          + Handgepäck
                          <InfoPopupHover
                            trigger={
                              <span>
                                <FaInfoCircle className="filterinfo" />
                              </span>
                            }
                            content={
                              "Zusätzlich zum angegebenen Gepäck dürfen Sie ein Handgepäck bis 8 kg mitnehmen. Bei Fragen wenden Sie sich an uns."
                            }
                            position={"right center"}
                          ></InfoPopupHover>
                        </span>
                      </div>
                    </div>
                  ) : null}
                  {packageInfo.inbound ? (
                    <div className="hoteloffervoucher18">
                      <div>
                        <img
                          src="https://holiday.placelogg.com/holidaymedia/koffer.png"
                          className="iconvoucher"
                        />
                        <span className="vouchericontext">
                          <span title="Rückflug">R:</span> {packageInfo.inbound}{" "}
                          + Handgepäck
                          <InfoPopupHover
                            trigger={
                              <span>
                                <FaInfoCircle className="filterinfo" />
                              </span>
                            }
                            content={
                              "Zusätzlich zum angegebenen Gepäck dürfen Sie ein Handgepäck bis 8 kg mitnehmen. Bei Fragen wenden Sie sich an uns."
                            }
                            position={"right center"}
                          ></InfoPopupHover>
                        </span>
                      </div>
                    </div>
                  ) : null}
                  {/*freeRebook ? (<>


                    <div className="hoteloffervoucher18">
                      kostenlose Umbuchung
                    </div></>
                  ) : null*/}{" "}
                </div>
              </div>
            </div>
            {mode !== "booking" || reservationselected ? (
              <div
                className={
                  "hoteloffervoucher39 " +
                  (status === -1
                    ? "voucherno"
                    : status === 1
                    ? "voucheryes"
                    : "voucherpending")
                }
              >
                <div
                  className={
                    Array.isArray(offer?.MarketingActions) &&
                    offer?.MarketingActions.length > 0 &&
                    offer?.MarketingActions[0].reservation
                      ? "optionavailable"
                      : "nooption"
                  }
                  dangerouslySetInnerHTML={{
                    __html:
                      Array.isArray(offer?.MarketingActions) &&
                      offer?.MarketingActions.length > 0 &&
                      offer?.MarketingActions[0].reservationtext,
                  }}
                ></div>
              </div>
            ) : (
              <div className="hoteloffervoucher39 "></div>
            )}

            {
              <CancellationOptions
                mode={mode}
                flexbooked={flexbooked}
                offer={offer}
                verbose={true}
              />
            }

            <div className="growbox" />
            <div className="hoteloffervoucher37">
              <img
                className="hoteloffervoucher19"
                src={offer.TourOperator.TourOperatorImage}
              />
            </div>
            <div className="betterplaceholder">{betterOffersButton}</div>
          </div>
        </div>
        <div
          className={
            "hoteloffervoucher21 " +
            (status === -1 ? "voucherno" : status === 1 ? "voucheryes" : "")
          }
        >
          <div className="hotelofferofferboardprice">
            <div className="hotelofferofferprice">
              {mode !== "booking" &&
                Array.isArray(offer.MarketingActions) &&
                offer.MarketingActions.filter((e) => e.typ_id === "0018-0001")
                  .length > 0 && (
                  <div
                    className="hoteloffervoucher5"
                    style={{
                      top: offerdiv.current
                        ? offerdiv.current.offsetTop + 10
                        : 0,
                      left: offerdiv.current
                        ? offerdiv.current.offsetLeft + 300
                        : 0,
                    }}
                  >
                    {" "}
                    {Array.isArray(offer?.MarketingActions) &&
                      offer.MarketingActions.filter(
                        (e) => e.typ_id === "0018-0001"
                      ).map((e, i) => (
                        <InfoPopupHover
                          trigger={
                            <div title={e.reason} className="tuiangebot">
                              {e.MarketingProperties && (
                                <span className="tuiangebotspan">
                                  {i > 0 && <span>oder</span>}
                                  {e.MarketingProperties?.actiontext}
                                </span>
                              )}
                            </div>
                          }
                          content={
                            e.MarketingProperties?.typ === "0022-0002"
                              ? "Der Cashback-Betrag wird von Ihrem Reisepreis abgezogen"
                              : e.MarketingProperties?.mouseover
                          }
                          position={"right center"}
                        ></InfoPopupHover>
                      ))}
                  </div>
                )}

              {mode === "booking" && (
                <div
                  className="hoteloffervoucher5"
                  style={{
                    top: offerdiv.current ? offerdiv.current.offsetTop + 10 : 0,
                    left: offerdiv.current
                      ? offerdiv.current.offsetLeft + 300
                      : 0,
                  }}
                >
                  {Array.isArray(selectedTOMarketingAction) &&
                    selectedTOMarketingAction
                      .filter((e) => e.typ_id === "0018-0001")
                      .map((e, i) => (
                        <div
                          className="tuiangebot"
                          title={e.reason}
                          style={{
                            display: "flex",
                            justifyContent: "flex-end",
                          }}
                        >
                          {e.MarketingProperties && (
                            <span
                              className="tuiangebotspan"
                              dangerouslySetInnerHTML={{
                                __html: e.MarketingProperties?.actiontext,
                              }}
                            ></span>
                          )}
                        </div>
                      ))}
                </div>
              )}
              <div className="hoteloffervoucher28">
                {mode !== "booking" &&
                  Array.isArray(offer?.MarketingActions) &&
                  offer.MarketingActions.filter((e) => e.typ_id === "0018-0002")
                    .sort((a, b) => {
                      return a.MarketingProperties.actiongroup <
                        b.MarketingProperties.actiongroup
                        ? -1
                        : a.MarketingProperties.actiongroup ==
                          b.MarketingProperties.actiongroup
                        ? 0
                        : 1;
                    })
                    .map((e, i) => {
                      let tmp = (
                        <InfoPopupHover
                          trigger={
                            <div title={e.reason}>
                              {e.MarketingProperties && (
                                <>
                                  {i > 0 &&
                                    marketingGroup ===
                                      e.MarketingProperties.actiongroup && (
                                      <div>
                                        <span className="hoteloffervoucher29">
                                          oder
                                        </span>
                                      </div>
                                    )}
                                  {i > 0 &&
                                    marketingGroup !==
                                      e.MarketingProperties.actiongroup && (
                                      <>
                                        <div>
                                          <span className="hoteloffervoucher29">
                                            und
                                          </span>
                                        </div>
                                      </>
                                    )}
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-end",
                                    }}
                                  >
                                    <div
                                      className="hoteloffervoucher36"
                                      dangerouslySetInnerHTML={{
                                        __html:
                                          e.MarketingProperties?.typ ===
                                          "0022-0002"
                                            ? "Der Cashback-Betrag wird vom Reisebüro erstattet."
                                            : "" + e.MarketingProperties?.text,
                                      }}
                                    ></div>
                                  </div>
                                </>
                              )}
                            </div>
                          }
                          content={e.MarketingProperties?.mouseover}
                          position={"right center"}
                        ></InfoPopupHover>
                      );
                      if (
                        marketingGroup !== e.MarketingProperties.actiongroup
                      ) {
                        marketingGroup = e.MarketingProperties.actiongroup;
                        if (i != 0) {
                          return (
                            <>
                              <div
                                style={{
                                  backgroundColor: "#ebe8e6",
                                  marginTop: "4px",
                                  height: "2px",
                                  width: "100%",
                                }}
                              ></div>
                              {tmp}
                            </>
                          );
                        }
                      }
                      return <>{tmp}</>;
                    })}

                {mode === "booking" &&
                  Array.isArray(selectedTAMarketingAction) &&
                  selectedTAMarketingAction
                    .filter((e) => e.typ_id === "0018-0002")
                    .map((e, i) => (
                      <div
                        title={e.reason}
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        {e.MarketingProperties && (
                          <div
                            className="hoteloffervoucher36"
                            dangerouslySetInnerHTML={{
                              __html: "" + e.MarketingProperties?.text,
                            }}
                          ></div>
                        )}
                      </div>
                    ))}
              </div>
              <div>
                <div className="hoteloffervoucher33">
                  <div className="hoteloffervoucherprice">
                    <div className="hotelofferofferpricevalue">
                      {flexprice > -1 && (
                        <div
                          style={{
                            borderBottom: "1px solid black",
                          }}
                        >
                          <div style={{ display: "flex" }}>
                            <div style={{ flexGrow: 1, textAlign: "left" }}>
                              Angebotspreis:
                            </div>
                            <div>
                              <FormattedNumber
                                value={reducedprice}
                                minimumFractionDigits={2}
                                maximumFractionDigits={2}
                              />{" "}
                              {currencySymbol(
                                offer.PriceInfo.Price.CurrencyCode
                              )}
                            </div>
                          </div>
                          <div style={{ display: "flex" }}>
                            <div style={{ flexGrow: 1, textAlign: "left" }}>
                              Flexoption:
                            </div>
                            <div>
                              <FormattedNumber
                                value={flexprice}
                                minimumFractionDigits={2}
                                maximumFractionDigits={2}
                              />{" "}
                              {currencySymbol(
                                offer.PriceInfo.Price.CurrencyCode
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                      <span className="hoteloffervoucher34">
                        Ihr Gesamtpreis
                      </span>
                      <br />
                      <span className="hoteloffervoucher35">
                        {mode !== "booking" && (
                          <FormattedNumber
                            value={
                              realprice > 0
                                ? realprice
                                : offer.PriceInfo.Price.value *
                                  (offer.adults * 1 + offer.children * 1)
                            }
                            minimumFractionDigits={2}
                            maximumFractionDigits={2}
                          />
                        )}
                        {mode === "booking" && (
                          <FormattedNumber
                            value={bookingprice}
                            minimumFractionDigits={2}
                            maximumFractionDigits={2}
                          />
                        )}{" "}
                        {currencySymbol(offer.PriceInfo.Price.CurrencyCode)}
                      </span>
                      <div className="hoteloffervoucher25">
                        {offer.adults * 1 + offer.children * 1 > 1 && (
                          <>
                            <br></br>
                            {mode !== "booking" && (
                              <span>
                                {realprice > 0 &&
                                  nf.format(
                                    Math.round(
                                      ((realprice /
                                        (offer.adults * 1 +
                                          offer.children * 1)) *
                                        100) /
                                        100
                                    ).toFixed(0)
                                  )}
                                {realprice === 0 && offer.PriceInfo.Price.value
                                  ? nf.format(
                                      (
                                        Math.round(
                                          offer.PriceInfo.Price.value * 100
                                        ) / 100
                                      ).toFixed(0)
                                    )
                                  : ""}{" "}
                                {currencySymbol(
                                  offer.PriceInfo.Price.CurrencyCode
                                )}{" "}
                                pro Person
                              </span>
                            )}
                            {mode === "booking" && (
                              <span>
                                {bookingpersonprice
                                  ? nf.format(bookingpersonprice)
                                  : ""}{" "}
                                {currencySymbol(
                                  offer.PriceInfo.Price.CurrencyCode
                                )}{" "}
                                pro Person
                              </span>
                            )}
                            <br></br>
                          </>
                        )}
                        <span>inkl. aller Steuern und Gebühren</span>
                      </div>
                    </div>
                  </div>
                </div>
                {Array.isArray(
                  offer?.bookinginfo?.AvailablePaymentTypes?.Payment
                ) ? (
                  <div className="hoteloffervoucher30">
                    {offer.bookinginfo.AvailablePaymentTypes.Payment.filter(
                      (e) => e.$.Type === "CreditCard"
                    ).map((e, i) => {
                      return (
                        <div className="hoteloffervoucher31">
                          {paymentOptions.find(
                            (ec) => e.CreditCard.$.CardType === ec.id
                          ) && (
                            <>
                              {
                                paymentOptions.find(
                                  (ec) => e.CreditCard.$.CardType === ec.id
                                ).icon
                              }
                            </>
                          )}
                        </div>
                      );
                    })}
                    {Array.isArray(
                      offer?.bookinginfo?.AvailablePaymentTypes?.Payment
                    ) && (
                      <>
                        {offer.bookinginfo.AvailablePaymentTypes.Payment.filter(
                          (e) =>
                            e.$.Type === "DirectDebitInternational" ||
                            e.$.Type === "BankTransfer" ||
                            e.$.Type === "Phone"
                        ).map((e, i) => (
                          <div className="hoteloffervoucher27">
                            {paymentOptions.find(
                              (ec) => e.$.Type === ec.id
                            ) && (
                              <>
                                {
                                  paymentOptions.find(
                                    (ec) => e.$.Type === ec.id
                                  ).icon
                                }
                              </>
                            )}
                          </div>
                        ))}
                      </>
                    )}
                  </div>
                ) : (
                  <div className="hoteloffervoucher30"></div>
                )}
                {/*<div className="growbox">Cache{Array.isArray(offer?.MarketingActions) && offer.MarketingActions.length > 0 &&   <>{JSON.stringify(offer.MarketingActions[0].cache)}</>}</div>*/}

                <div className="hotelofferavailabilitybutton">
                  {availabilityButton}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
